module.exports = __webpack_public_path__ + "C449C5FFAFA1C27C6A60C62A5BE3EF21advantage1.94fe9553.png";